import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function FutureSection() {
  const benefits = [{
    emoji: '📱',
    title: "Vous ouvrez l'app avec confiance, pas avec anxiété.",
    desc: 'Vous savez exactement quoi faire.'
  }, {
    emoji: '💬',
    title: 'Vos conversations ne meurent plus.',
    desc: "Vous avez les scripts. Il n'a aucune chance de s'ennuyer."
  }, {
    emoji: '🗓️',
    title: 'Vous choisissez vos rendez-vous.',
    desc: 'Plus question d\'accepter un "T\'es libre ce soir ?" de dernière minute.'
  }, {
    emoji: '🚫',
    title: 'Vous identifiez les imposteurs en 3 messages.',
    desc: 'Fini les mois perdus avec les mauvaises personnes.'
  }, {
    emoji: '👑',
    title: "Vous devenez celle qu'on n'ose pas ghoster.",
    desc: 'Parce que perdre votre attention devient insupportable pour lui.'
  }];
  return <section className="py-16 md:py-32 relative bg-gradient-to-b from-deep-black to-[#110a0c]" data-id="element-112">
      <div className="max-w-4xl mx-auto px-6" data-id="element-113">
        <FadeIn data-id="element-114">
          <h2 className="font-playfair text-3xl md:text-5xl text-center text-cream mb-16 leading-tight" data-id="element-115">
            À quoi ressemblera votre vie dans{' '}
            <span className="text-champagne-gold italic" data-id="element-116">21 jours</span>
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-117">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.15} direction="left" data-id="element-118">
              <div className="flex items-start gap-6 p-6 rounded-2xl bg-deep-black/40 border border-white/5 hover:border-champagne-gold/30 transition-colors duration-300" data-id="element-119">
                <div className="text-3xl mt-1" data-id="element-120">{benefit.emoji}</div>
                <div data-id="element-121">
                  <h3 className="text-lg md:text-xl font-medium text-cream mb-2" data-id="element-122">
                    {benefit.title}
                  </h3>
                  <p className="text-muted-cream font-light text-sm md:text-base" data-id="element-123">
                    {benefit.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}